<!--
 * @Description: 查看图片组件
 * @Author: 房旭
 * @LastEditors: 房旭
 * @Date: 2019-02-25 13:51:00
 * @LastEditTime: 2019-02-25 15:44:51
 -->
<template>
    <div>
        <div>
            <div class="demo-upload-list">
                <img :src="img">
                <div class="demo-upload-list-cover">
                    <icon type="ios-eye-outline" @click.native="handleView()"></icon>
                </div>
            </div>
        </div>
        <modal title="图片预览" v-model="visible">
            <img :src="img" v-if="visible" style="width: 100%">
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            //图片src对应的url
            img: {
                type: String
            }
        },
        data() {
            return {
                visible: false//是否显示弹出modal框
            };
        },
        components: {

        },
        methods: {
            //显示图片的方法
            handleView(name) {
                this.imgName = name;
                this.visible = true;
            }
        }
    };
</script>

<style scoped lang="less">
    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>